import { createSelector } from "reselect";

const selectFwuVersionsState = (state) => state.fwuVersions;

const selectFwuVersionToEdit = () =>
  createSelector(selectFwuVersionsState, (fwuVersionsState) => fwuVersionsState?.fwuVersionToEdit);

const selectFwuVersionToDelete = () =>
  createSelector(
    selectFwuVersionsState,
    (fwuVersionsState) => fwuVersionsState?.fwuVersionToDelete
  );

const selectReleaseNotesMedia = () =>
  createSelector(selectFwuVersionsState, (fwuVersionsState) => {
    return {
      releaseNotesMedia: fwuVersionsState?.releaseNotesMedia,
      releaseNotesThumbnails: fwuVersionsState?.releaseNotesThumbnails
    };
  });

export { selectFwuVersionToEdit, selectFwuVersionToDelete, selectReleaseNotesMedia };
